import { useSelector } from 'react-redux';
import getToggles from '../selectors/togglesSelector';

const useToggles = () => useSelector(getToggles);

export default useToggles;
